var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.active)?_c('Editor',{attrs:{"disabled":true,"api-key":"jh5j9j89wyv5mbctvucc67e0o5ba3q7v4xkldjfoaqv74glt","init":_vm.inital},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }